import React from 'react';

export const Unhautorized: React.FC = () => {
    return <div>Unhautorized!</div>;
};
